import { useEffect, useState } from "react";
import useMobileDetect from "./useMobileDetect";
import useWindowResize from "./useWindowResize";

export default function useMobile() {
	const [isMobile, setIsMobile] = useState(false);

	const windowSize = useWindowResize();
	const detectMobile = useMobileDetect();

	useEffect(() => {
		const byUa = detectMobile.isMobile();
		const byWidth = typeof windowSize.width === "number" && windowSize.width < 768;
		setIsMobile(byUa || byWidth);
	}, [detectMobile, windowSize]);

	return isMobile;
}
